// extracted by mini-css-extract-plugin
export var container = "_h2-0";
export var content = "_h2-3";
export var customerTitle = "_h2-4";
export var empty = "_h2-5";
export var gray = "_h2-6";
export var header = "_h2-7";
export var info = "_h2-8";
export var loading = "_h2-2";
export var loadingCard = "_h2-9";
export var oneLine = "_h2-a";
export var personName = "_h2-e";
export var pillContainer = "_h2-b";
export var selected = "_h2-1";
export var text = "_h2-c";
export var twoLines = "_h2-d";
export var unread = "_h2-f";
export var unreadIndicator = "_h2-g";